<template>
  <section>
    <b-modal :active.sync="isComponentModalActive" has-modal-card :can-cancel="false">
      <div class="modal-card">
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        <header class="modal-card-head">
          <p v-if="!this.stablishment_id" class="modal-card-title">Crear Establecimientob</p>
          <p v-else class="modal-card-title">Editar Establecimiento</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Nombre">
            <b-input
              type="text"
              :value="stablishment.name"
              v-model="stablishment.name"
              placeholder="Nombre"
              required
            ></b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="closeBasic()">Cerrar</button>
          <button v-if="!this.stablishment_id" class="button is-primary" @click="createStablishment()">Guardar</button>
          <button v-else class="button is-primary" @click="editStablishment()">Editar</button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>
<script>

import {StablishmentService} from "./../../../services/models/stablishment";

export default {
  props: [
    "isComponentModalActive",
    "closeBasic",
    "chargeStablishmentList",
    "stablishment_id",
  ],
  data() {
    return {
      stablishment: {
        name: "",
      },
      isLoading: false,
    };
  },
  async created () {
    this.isLoading = true;
    if (this.stablishment_id) {
      const {data} = await StablishmentService.getById(this.stablishment_id);
      this.stablishment = data;
    }
    this.isLoading = false;
  },
  methods: {
    async createStablishment () {
      this.isLoading = true;
      try {
        await StablishmentService.create(this.stablishment);
        this.chargeStablishmentList();
        this.closeBasic();
        this.toast("Creado el establecimiento", "is-success");
      } catch (err) {
        this.toast("Error al crear", "is-danger");
      }
      this.isLoading = false;
    },
    async editStablishment () {
      this.isLoading = true;
      try {
        await StablishmentService.update( this.stablishment_id,this.stablishment);
        this.chargeStablishmentList();
        this.closeBasic();
        this.toast("Editado el establecimiento", "is-success");
      } catch (error) {
        this.toast("Error al editar", "is-danger");
      }
      this.isLoading = false;
    }
  },
};
</script>